export enum OutputFileFormatTypes {
  pdf = 'pdf',
  jpg = 'jpg',
  html = 'html',
}
